module.exports = __webpack_public_path__ + "img/2-1.7f449da3.png";